import type {MarkerPrecision} from './cadRegions';

export type MarkerNotice={kind:'exact'|'approximate'|'missing'|'other_page';text:string};

/**
 * What the viewer says about the CAD marker of the addressed value. The same wording is used in
 * the work inspector and in the side-by-side comparison: an estimated box is never shown as proven,
 * and a value without a marker always says why.
 */
export function cadMarkerNotice({hasRecord,precision,text,compared,elsewhere,others}:{hasRecord:boolean;precision:MarkerPrecision;text:string;compared:boolean;elsewhere:boolean;others:number}):MarkerNotice|undefined {
  if(!hasRecord) return undefined;
  const button=compared?'«К выделенному значению»':'«К основанию работы»';
  if(precision==='unresolved') return elsewhere
    ? {kind:'other_page',text:`Значение «${text}» находится на другой странице. Перейдите к нему кнопкой ${button}.`}
    : {kind:'missing',text:'Точная область значения не найдена в исходных данных, поэтому отметка не показана. Проверьте лист вручную.'};
  const more=others>0?` · ещё ${others} отметок на этой странице`:'';
  return precision==='exact'
    ? {kind:'exact',text:`Точно выделено значение «${text}»${more}. Область подтверждена данными источника. Кнопка ${button} приближает его.`}
    : {kind:'approximate',text:`Приблизительно отмечено значение «${text}»${more}. Точная область в исходных данных отсутствует — проверьте лист. Кнопка ${button} приближает его.`};
}

/**
 * PDF regions locate actual text, but the link between that text and an observation can be inferred. Addresses the source does not contain
 * have their own message; this one covers addresses that exist but carry no usable area.
 */
export function pdfMarkerNotice({anchor,highlighted,unlocated,missing,precision='exact'}:{precision?:MarkerPrecision;anchor:string;highlighted:boolean;unlocated:string[];missing:string[]}):MarkerNotice|undefined {
  if(!anchor) return undefined;
  const withoutArea=unlocated.filter(key=>!missing.includes(key));
  if(highlighted && precision==='approximate') return {kind:'approximate',text:'Приблизительная отметка: строка подобрана по марке и значению. Проверьте её соответствие на листе.'};
  if(highlighted) return {kind:'exact',text:`Точно выделено: область значения записана в данных источника.${withoutArea.length?` Ещё у ${withoutArea.length} адресов нет области на листе — отметки для них не показаны.`:''}`};
  if(!withoutArea.includes(anchor)) return undefined;
  return {kind:'missing',text:'У строки источника нет области на листе, поэтому отметка не показана. Значение можно найти в тексте листа или поиском по источнику.'};
}
